import React, { useState } from 'react';
import { MessageCircle, X, Headphones } from 'lucide-react';

/**
 * FloatingChat — a fixed bottom-corner chat launcher. Clicking the round button
 * opens a panel that renders `children` (the actual chat UI). Shows an unread
 * badge on the button while closed.
 */
const FloatingChat = ({ unread = 0, title = 'الدعم الفني', children, panelClassName = 'max-w-[380px] h-[72vh]' }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {open && (
        <div
          className="fixed inset-0 z-[60] bg-black/20"
          onClick={() => setOpen(false)}
        />
      )}
      <div className="fixed bottom-4 left-4 z-[61] flex flex-col items-start gap-2" dir="rtl">
        {open && (
          <div className={`bg-white border border-[#E8DFCF] rounded-2xl shadow-2xl overflow-hidden flex flex-col w-[92vw] ${panelClassName}`}>
            <div className="flex items-center justify-between px-3 py-2 bg-[#EF9F27] text-white shrink-0">
              <div className="flex items-center gap-2 font-semibold text-sm">
                <Headphones className="w-4 h-4" /> {title}
              </div>
              <button onClick={() => setOpen(false)} className="hover:bg-white/20 rounded p-1" aria-label="إغلاق">
                <X className="w-4 h-4" />
              </button>
            </div>
            <div className="flex-1 min-h-0">{children}</div>
          </div>
        )}

        <button
          onClick={() => setOpen((v) => !v)}
          className="relative w-14 h-14 rounded-full bg-[#EF9F27] hover:bg-[#D88E1F] text-white shadow-lg flex items-center justify-center transition-colors"
          data-testid="floating-chat-btn"
          title={title}
        >
          {open ? <X className="w-6 h-6" /> : <MessageCircle className="w-6 h-6" />}
          {!open && unread > 0 && (
            <span className="absolute -top-1 -right-1 min-w-[20px] h-5 px-1 bg-red-500 text-white text-[11px] rounded-full flex items-center justify-center">
              {unread > 99 ? '99+' : unread}
            </span>
          )}
        </button>
      </div>
    </>
  );
};

export default FloatingChat;
